// extracted by css-extract-rspack-plugin
export default {"RedirectMessage":"style-module__RedirectMessage___UiHDY","redirectMessage":"style-module__RedirectMessage___UiHDY","mobile":"style-module__mobile___dqcln"};